import { fetch } from 'app/utils/data'
import deserialize from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    getByType: (state) => (type) => state.list.map(i => i[type]).filter(i => i)
  },

  mutations: {
    fetched(state, { popularityList }) {
      state.list = popularityList.icons
    },

    resetState: (state) => {
      state.list = []
    }
  },

  actions: {
    async fetchPopularIcons({ commit }) {
      try {
        const response = await fetch({
          url: `/api/icon-popularity-list`,
          type: 'popularity-list'
        })
        const popularityList = await deserialize(response.data)

        commit('fetched', { popularityList })

        return Promise.resolve(popularityList)
      } catch (e) {
        return Promise.reject(e)
      }
    }
  }
}
